import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { LogoMark } from "./Logo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Handles the return from Emergent Google OAuth.
 * The Emergent redirect appends `#session_id=<id>` to the URL — we read it
 * exactly once (via useRef), exchange it for a session cookie, and then send
 * the user to /member.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
 * THIS BREAKS THE AUTH.
 */
const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) {
      navigate("/member-login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        // Clear the fragment before navigating away
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/member", { replace: true, state: { user: data.user } });
      } catch {
        navigate("/member-login", { replace: true });
      }
    })();
  }, [location.hash, navigate]);

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center bg-neutral-50">
      <LogoMark size={64} />
      <p className="mt-6 text-neutral-600 text-sm">Signing you in securely…</p>
    </div>
  );
};

export default AuthCallback;
